module.exports = __webpack_public_path__ + "img/42.e429ac67.jpg";